import { Link } from "react-router-dom";
import { Truck, ShieldCheck, Warehouse, Ship, Plane, Boxes, ClipboardCheck, ArrowRight, PackageCheck } from "lucide-react";

const services = [
  {
    icon: Truck,
    title: "In-Land Transportation",
    desc: "Full inland cargo handling with a reliable fleet across India. We provide door-to-door pickup and delivery services, ensuring your goods reach their destination safely and on time. Our extensive network covers all major cities and industrial hubs.",
    image: "https://images.unsplash.com/photo-1665600291795-4df1c15162a8?crop=entropy&cs=srgb&fm=webp&w=600&q=70&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHw0fHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMGN1c3RvbXMlMjBvZmZpY2VyJTIwZG9jdW1lbnRzJTIwd2FyZWhvdXNlJTIwaW50ZXJpb3IlMjBjb250YWluZXIlMjBzaGlwJTIwb2NlYW4lMjBjYXJnbyUyMHBsYW5lJTIwYWlycG9ydCUyMGhlYXZ5JTIwbWFjaGluZXJ5JTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3NzI0NDgyNzJ8MA&ixlib=rb-4.1.0",
  },
  {
    icon: ShieldCheck,
    title: "Customs Clearance",
    desc: "Licensed, hassle-free customs clearance services with expert documentation handling. Our certified customs brokers navigate complex regulations to ensure smooth and timely clearance for both import and export shipments.",
    image: "https://images.unsplash.com/photo-1589725971583-8fa4d89e5e33?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMGN1c3RvbXMlMjBvZmZpY2VyJTIwZG9jdW1lbnRzJTIwd2FyZWhvdXNlJTIwaW50ZXJpb3IlMjBjb250YWluZXIlMjBzaGlwJTIwb2NlYW4lMjBjYXJnbyUyMHBsYW5lJTIwYWlycG9ydCUyMGhlYXZ5JTIwbWFjaGluZXJ5JTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3NzI0NDgyNzJ8MA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: Warehouse,
    title: "Warehousing & Storage",
    desc: "Secure and well-managed warehousing facilities for all types of cargo. We offer flexible short-term and long-term storage solutions with proper inventory management, climate control options, and 24/7 security surveillance.",
    image: "https://images.unsplash.com/photo-1705239738282-84924db4b056?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMGN1c3RvbXMlMjBvZmZpY2VyJTIwZG9jdW1lbnRzJTIwd2FyZWhvdXNlJTIwaW50ZXJpb3IlMjBjb250YWluZXIlMjBzaGlwJTIwb2NlYW4lMjBjYXJnbyUyMHBsYW5lJTIwYWlycG9ydCUyMGhlYXZ5JTIwbWFjaGluZXJ5JTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3NzI0NDgyNzJ8MA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: Ship,
    title: "Ocean Freight",
    desc: "Competitive international ocean shipping solutions for both FCL and LCL cargo. We partner with leading shipping lines to offer the best rates and transit times across major global trade routes.",
    image: "https://images.unsplash.com/photo-1759826350352-c5b0b77729bd?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwY29udGFpbmVyJTIwc2hpcCUyMGFpcnBsYW5lJTIwdHJ1Y2slMjB3YXJlaG91c2V8ZW58MHx8fHwxNzcyNDQ4MjUyfDA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: Plane,
    title: "Air Freight",
    desc: "Fast and reliable air cargo services for time-sensitive shipments. We provide door-to-door air freight solutions with options for express, consolidated, and charter services to destinations worldwide.",
    image: "https://images.unsplash.com/photo-1740088314470-72dd4767653c?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwY29udGFpbmVyJTIwc2hpcCUyMGFpcnBsYW5lJTIwdHJ1Y2slMjB3YXJlaG91c2V8ZW58MHx8fHwxNzcyNDQ4MjUyfDA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: Boxes,
    title: "Project Cargo & Consultancy",
    desc: "Specialized handling of oversized, heavy-lift, and high-value project cargo. Our experienced team provides end-to-end project logistics consultancy, from route surveys to cargo insurance and execution planning.",
    image: "https://images.unsplash.com/photo-1724525231969-173f10849bb1?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwY29udGFpbmVyJTIwc2hpcCUyMGFpcnBsYW5lJTIwdHJ1Y2slMjB3YXJlaG91c2V8ZW58MHx8fHwxNzcyNDQ4MjUyfDA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: ClipboardCheck,
    title: "Third-Party Survey Services",
    desc: "Professional inspection and survey support for all types of cargo. Our trained surveyors conduct pre-shipment inspections, damage assessments, and loading/unloading surveys to protect your interests.",
    image: "https://images.unsplash.com/photo-1589725971583-8fa4d89e5e33?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwzfHxjYXJnbyUyMHRydWNrJTIwaGlnaHdheSUyMGN1c3RvbXMlMjBvZmZpY2VyJTIwZG9jdW1lbnRzJTIwd2FyZWhvdXNlJTIwaW50ZXJpb3IlMjBjb250YWluZXIlMjBzaGlwJTIwb2NlYW4lMjBjYXJnbyUyMHBsYW5lJTIwYWlycG9ydCUyMGhlYXZ5JTIwbWFjaGluZXJ5JTIwY29uc3RydWN0aW9uJTIwc2l0ZXxlbnwwfHx8fDE3NzI0NDgyNzJ8MA&ixlib=rb-4.1.0&q=70",
  },
  {
    icon: PackageCheck,
    title: "Import & Export Cargo",
    desc: "Complete import and export cargo handling services. From documentation to delivery, we manage the entire process ensuring compliance with all trade regulations and achieving the fastest possible turnaround times.",
    image: "https://images.unsplash.com/photo-1705239738282-84924db4b056?crop=entropy&cs=srgb&fm=webp&w=600&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNhcmdvJTIwY29udGFpbmVyJTIwc2hpcCUyMGFpcnBsYW5lJTIwdHJ1Y2slMjB3YXJlaG91c2V8ZW58MHx8fHwxNzcyNDQ4MjUyfDA&ixlib=rb-4.1.0&q=70",
  },
];

export default function ServicesPage() {
  return (
    <div>
      {/* Page Header */}
      <section className="page-header py-20 md:py-28" data-testid="services-page-header">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-['Barlow_Condensed'] font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white mb-4" data-testid="services-heading">
            Our Services
          </h1>
          <p className="text-slate-300 text-base md:text-lg max-w-2xl mx-auto">
            Comprehensive logistics solutions tailored to your business needs
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 md:py-24 bg-white" data-testid="services-grid-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-[#F97316] font-semibold text-sm uppercase tracking-widest">What We Offer</span>
            <h2 className="font-['Barlow_Condensed'] font-bold text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] mt-3 mb-4">
              End-to-End Logistics Solutions
            </h2>
            <div className="section-divider mx-auto mb-6" />
            <p className="text-slate-600 max-w-2xl mx-auto">
              From the first mile to the last, we ensure your cargo reaches its destination through our comprehensive range of logistics services.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, i) => (
              <div
                key={service.title}
                className="service-card group bg-white border border-slate-200 hover:border-[#0EA5E9] rounded-lg overflow-hidden flex flex-col"
                data-testid={`service-card-${i}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="service-image w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A]/60 to-transparent" />
                  <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg p-2.5">
                    <service.icon size={24} strokeWidth={1.5} className="text-[#0EA5E9]" />
                  </div>
                </div>
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="font-['Barlow_Condensed'] font-bold text-xl text-[#0F172A] mb-3">{service.title}</h3>
                  <p className="text-slate-500 text-sm leading-relaxed flex-grow mb-4">{service.desc}</p>
                  <Link
                    to="/contact"
                    className="text-[#F97316] text-sm font-semibold inline-flex items-center gap-1 hover:gap-2 transition-all"
                    data-testid={`service-cta-${i}`}
                  >
                    Get a Quote <ArrowRight size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-[#0F172A] to-[#1E293B]" data-testid="services-cta-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-['Barlow_Condensed'] font-bold text-3xl sm:text-4xl text-white mb-4">
            Need a Custom Logistics Solution?
          </h2>
          <p className="text-slate-300 text-base max-w-xl mx-auto mb-8">
            Our team of experts can create a tailored logistics plan that fits your specific requirements and budget.
          </p>
          <Link to="/contact" className="btn-primary inline-flex items-center gap-2" data-testid="services-cta-contact-btn">
            Contact Our Team <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
